import { calendarMonthBounds, toBusinessDate } from 'config/time';
import React, { useState, useEffect } from "react";
import { IoCalendarOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

interface MonthFilterProps {
  onDateRangeChange: (range: { start: string, end: string }) => void;
}

const MonthFilter: React.FC<MonthFilterProps> = ({ onDateRangeChange }) => {
  // ADM-05。初期の月と年は業務時間帯（会社の時間帯）の業務日で決める（端末の時間帯で決めていた）。
  const [selectedMonth, setSelectedMonth] = useState(
    () => Number(toBusinessDate(new Date()).slice(5, 7)) - 1
  );

  const { t, i18n } = useTranslation();
  // 表示言語の月名（日本語は「10月」）。英語の固定配列だった。
  const monthFormat = new Intl.DateTimeFormat(
    i18n.language === 'jp' ? 'ja-JP' : 'en-US',
    { month: 'long', timeZone: 'UTC' }
  );
  const months = Array.from({ length: 12 }, (_, index) =>
    monthFormat.format(new Date(Date.UTC(2026, index, 1)))
  );

  const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const monthIndex = parseInt(event.target.value);
    setSelectedMonth(monthIndex);
  };

  const getMonthDateRange = (monthIndex: number) => {
    const year = Number(toBusinessDate(new Date()).slice(0, 4));
    // ADM-05。業務日（会社の時間帯）の年で月の範囲を作る。EV-116 段階2。暦日は日付の文字列のまま
    // 計算する（Date.UTC の0時を業務時間帯で読むと、UTC より西の時間帯で前の日になっていた）。
    return calendarMonthBounds(year, monthIndex + 1);
  };

  useEffect(() => {
    const range = getMonthDateRange(selectedMonth);
    onDateRangeChange(range);
  }, [selectedMonth, onDateRangeChange]);

  return (
    <div className="relative inline-block font-semi-bold focus:outline-none">
      {/* EV-413（axe の select-name）。月の選択に名前が無かった。 */}
      <select
        aria-label={t('date-filter.month-label', { ns: 'common' })}
        value={selectedMonth}
        onChange={handleMonthChange}
        className="py-2 px-6 pr-8 text-primary/300 bg-white rounded-md appearance-none focus:outline-none"
      >
        {months.map((month, index) => (
          <option key={index} value={index}>
            {months[index]}
          </option>
        ))}
      </select>
      <IoCalendarOutline className="absolute right-2 top-1/2 transform -translate-y-1/2 text-primary/300" />
    </div>
  );
}

export default MonthFilter;